<template>
  <div class="max-w-100 mx-auto border border-black rounded-lg p-4 mt-6">
    <!-- Publish Date -->
    <p class="text-sm text-gray-700 mb-2">{{ formattedDate }}</p>

    <!-- Blog Title -->
    <h2 class="text-xl font-bold mb-4 cursor-pointer hover:underline">
      <a :href="link">{{ title }}</a>
    </h2>

    <!-- Blog Description -->
    <p class="text-base text-gray-800 mb-4">
      {{ description }}
    </p>

    <!-- Tags -->
    <div class="flex flex-wrap gap-2">
      <span
        v-for="tag in tags"
        :key="tag"
        class="px-2 py-1 border border-black text-sm font-medium rounded"
      >
        {{ tag }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BlogItem',
  props: {
    link: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    description: {
      type: String,
      required: true
    },
    publishDate: {
      type: String,
      required: true
    },
    tags: {
      type: Array,
      required: true
    }
  }
}
</script>

<style scoped>
/* Optional: additional styles for gray text */
.text-gray-700 {
  color: #333333;
}
.text-gray-800 {
  color: #1a1a1a;
}
</style>
